<template>
  <div
    class="common-title font-34 p-0-16 fb fb-cross-center fb-main-center relative"
  >
    <!-- <div class="ff-regular absolute text-ellipsis title-close"
      ><i class="iconfont pr-6">&#xe6f3;</i>关闭</div
    > -->
    <div class="ff-medium text-ellipsis text-center title-content">{{
      title
    }}</div>
    <div
      class="ff-regular absolute text-ellipsis text-right title-menu"
      @click="handlerRightMenu"
      >{{
        rightMenu.length > 1
          ? '更多'
          : rightMenu.length === 1
          ? rightMenu[0].name
          : ' '
      }}</div
    >
  </div>
</template>

<script>
import { showMcMenu } from '@/utils/mcSdkUtils'
export default {
  name: '',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    rightMenu: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerRightMenu() {
      const len = (this.rightMenu || []).length
      if (!len) {
        return false
      } else if (len === 1) {
        this.$router.push(this.rightMenu[0].value)
      } else {
        showMcMenu()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-title {
  height: 44px !important;
}
.title-close {
  width: 20%;
  left: 16px;
}
.title-menu {
  width: 20%;
  right: 16px;
}
.title-content {
  width: 50%;
}
</style>
